import type { IAccessRoleRepository } from '../../domain/repositories/IAccessRoleRepository';
import type { AccessRole } from '../../domain/entities/AccessRole';
import { LocalAccessRoleRepository } from './LocalAccessRoleRepository';
import { httpClient } from '@/shared/api/httpClient';
import type { AccessRolesResponseDTO } from '../dto/AccessRoleDTO';
import { toAccessRole } from '../mappers/accessRoleMapper';
import type { ApiError } from '@/shared/api/ApiError';

export class CompositeAccessRoleRepository implements IAccessRoleRepository {
  private readonly local = new LocalAccessRoleRepository();

  async listAll(): Promise<AccessRole[]> {
    try {
      // Fetch raw DTOs to cache them too
      const { data } = await httpClient.get<AccessRolesResponseDTO>('/v1/clock/app/devices');
      const dtos = data.data.results.filter((dto) => dto.status === 1);
      const roles = dtos.map(toAccessRole);
      void this.local.upsertAll(roles, dtos);
      return roles;
    } catch (err) {
      const apiErr = err as ApiError;
      if (apiErr.kind === 'network' || apiErr.kind === 'timeout') {
        return this.local.listAll();
      }
      throw err;
    }
  }
}
